import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ZipcodePipe } from './zipcode.pipe';

@NgModule({
    imports: [CommonModule],
    declarations: [ZipcodePipe],
    providers: [ZipcodePipe],
    exports: [ZipcodePipe],
})
export class ZipcodePipeModule {}
